module.exports = __webpack_public_path__ + "static/img/l5.31c97a80.png";